// import React, { useMemo } from "react";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate and Link
import { generateGuid, formatDate } from "../../Common/utils/utils";
import ReactTimeAgo from "react-time-ago";
import ModalConfirm from "./../../Common/misc/ModalConfirm";
import { toast } from "react-toastify";

import { useSelector, useDispatch } from "react-redux"; // Import useSelector and useDispatch
import {
  fetchIntegrations,
  deleteIntegrationAsync,
} from "../../Redux/slices/integrationSlice"; // Import the async thunk

// https://www.creative-tim.com/twcomponents/component/table-with-filter-and-search

const Listing = () => {
  const navigate = useNavigate(); // Get the navigate function

  const dispatch = useDispatch();
  const integrations = useSelector((state) => state.integration.integrations);
  const integrationsCount = useSelector(
    (state) => state.integration.integrationsCount
  );
  const status = useSelector((state) => state.integration.status);
  const error = useSelector((state) => state.integration.error);

  const [listFilterStatus, setListFilterStatus] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedItemToDelete, setSelectedItemeToDelete] = useState(null);
  // const [pageSize, setPageSize] = useState(10);

  const showPagination = false;
  const pageSize = 10;

  useEffect(() => {
    dispatch(
      fetchIntegrations({
        page: currentPage,
        page_size: pageSize,
        status: listFilterStatus,
      })
    ); // Pass as an object
  }, [dispatch, currentPage, pageSize, listFilterStatus]);

  // useEffect(() => {
  //   dispatch(fetchIntegrations(currentPage, pageSize, listFilterStatus));
  // }, [listFilterStatus])

  const totalPages = () => {
    return Math.ceil(integrationsCount / pageSize);
  };

  const handleRefresh = () => {
    dispatch(
      fetchIntegrations({
        page: currentPage,
        pageSize: pageSize,
        status: listFilterStatus,
      })
    );
    // toast.info('Refreshing data...');
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages()) {
      setCurrentPage(page);
    }
  };

  const getStatus = (status) => {
    if (status === "Running") {
      return (
        <span className="me-2 rounded-md bg-green-300 px-2.5 py-0.5 text-xs font-medium text-green-800 dark:bg-green-900 dark:text-green-300">
          {status}
        </span>
      );
    } else if (status === "Failed") {
      return (
        <span className="me-2 rounded-md bg-red-300 px-2.5 py-0.5 text-xs font-medium text-red-800 dark:bg-red-900 dark:text-red-300">
          {status}
        </span>
      );
    } else if (status === "Stopped") {
      return (
        <span className="me-2 rounded-md bg-yellow-300 px-2.5 py-0.5 text-xs font-medium text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300">
          {status}
        </span>
      );
    } else if (status === "Draft") {
      return (
        <span className="me-2 rounded-md bg-gray-300 px-2.5 py-0.5 text-xs font-medium text-gray-800 dark:bg-gray-900 dark:text-gray-300">
          {status}
        </span>
      );
    }
  };

  const handleGotoHome = () => {
    navigate("/"); // Go back one step in history
  };

  const gotoAddItem = () => {
    var newGuid = generateGuid();
    navigate(`/integrations/${newGuid}/overview`); // Navigate to the next page
    //router.push("/add-integration/overview"); // Navigates to the /about page
  };

  const editItem = (itemId) => {
    navigate(`/integrations/${itemId}/overview`); // Navigate to the next page
  };

  const deleteItem = async (itemId) => {
    setSelectedItemeToDelete(itemId);
  };

  const onConfirmCancel = () => {
    setSelectedItemeToDelete(null);
  };

  const onConfirm = async () => {
    try {
      // Dispatch the deleteIntegrationAsync thunk
      const resultAction = await dispatch(
        deleteIntegrationAsync(selectedItemToDelete)
      );

      // Check if the action was successful
      if (deleteIntegrationAsync.fulfilled.match(resultAction)) {
        dispatch(
          fetchIntegrations({
            page: currentPage,
            pageSize: pageSize,
            status: listFilterStatus,
          })
        );

        toast.success("Integration deleted successfully!");
      } else {
        toast.error("Failed to delete integration.");
      }
    } catch (err) {
      toast.error("An error occurred while deleting.");
    } finally {
      setSelectedItemeToDelete(null); // Close the modal
    }
  };

  const StatusIcon = ({ status }) => {
    switch (status) {
      case "Success":
        return (
          <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none">
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <path
                d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM16.78 9.7L11.11 15.37C10.97 15.51 10.78 15.59 10.58 15.59C10.38 15.59 10.19 15.51 10.05 15.37L7.22 12.54C6.93 12.25 6.93 11.77 7.22 11.48C7.51 11.19 7.99 11.19 8.28 11.48L10.58 13.78L15.72 8.64C16.01 8.35 16.49 8.35 16.78 8.64C17.07 8.93 17.07 9.4 16.78 9.7Z"
                fill="#15e411"
              ></path>{" "}
            </g>
          </svg>
        );
      case "Failed":
        return (
          <svg
            className="h-4 w-4"
            viewBox="0 0 32 32"
            version="1.1"
            fill="#000000"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <defs> </defs>{" "}
              <g
                id="Page-1"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
              >
                {" "}
                <g
                  id="Icon-Set-Filled"
                  transform="translate(-570.000000, -1089.000000)"
                  fill="#f24545"
                >
                  {" "}
                  <path
                    d="M591.657,1109.24 C592.048,1109.63 592.048,1110.27 591.657,1110.66 C591.267,1111.05 590.633,1111.05 590.242,1110.66 L586.006,1106.42 L581.74,1110.69 C581.346,1111.08 580.708,1111.08 580.314,1110.69 C579.921,1110.29 579.921,1109.65 580.314,1109.26 L584.58,1104.99 L580.344,1100.76 C579.953,1100.37 579.953,1099.73 580.344,1099.34 C580.733,1098.95 581.367,1098.95 581.758,1099.34 L585.994,1103.58 L590.292,1099.28 C590.686,1098.89 591.323,1098.89 591.717,1099.28 C592.11,1099.68 592.11,1100.31 591.717,1100.71 L587.42,1105.01 L591.657,1109.24 L591.657,1109.24 Z M586,1089 C577.163,1089 570,1096.16 570,1105 C570,1113.84 577.163,1121 586,1121 C594.837,1121 602,1113.84 602,1105 C602,1096.16 594.837,1089 586,1089 L586,1089 Z"
                    id="cross-circle"
                  >
                    {" "}
                  </path>{" "}
                </g>{" "}
              </g>{" "}
            </g>
          </svg>
        );
      case "Running":
        return (
          <svg
            className="h-4 w-4"
            viewBox="0 0 32 32"
            version="1.1"
            fill="#000000"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <defs> </defs>{" "}
              <g
                id="Page-1"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
              >
                {" "}
                <g
                  id="Icon-Set-Filled"
                  transform="translate(-570.000000, -1089.000000)"
                  fill="#0000ff"
                >
                  {" "}
                  <path
                    d="M591.657,1109.24 C592.048,1109.63 592.048,1110.27 591.657,1110.66 C591.267,1111.05 590.633,1111.05 590.242,1110.66 L586.006,1106.42 L581.74,1110.69 C581.346,1111.08 580.708,1111.08 580.314,1110.69 C579.921,1110.29 579.921,1109.65 580.314,1109.26 L584.58,1104.99 L580.344,1100.76 C579.953,1100.37 579.953,1099.73 580.344,1099.34 C580.733,1098.95 581.367,1098.95 581.758,1099.34 L585.994,1103.58 L590.292,1099.28 C590.686,1098.89 591.323,1098.89 591.717,1099.28 C592.11,1099.68 592.11,1100.31 591.717,1100.71 L587.42,1105.01 L591.657,1109.24 L591.657,1109.24 Z M586,1089 C577.163,1089 570,1096.16 570,1105 C570,1113.84 577.163,1121 586,1121 C594.837,1121 602,1113.84 602,1105 C602,1096.16 594.837,1089 586,1089 L586,1089 Z"
                    id="cross-circle"
                  >
                    {" "}
                  </path>{" "}
                </g>{" "}
              </g>{" "}
            </g>
          </svg>
        );
      default:
        return <span>&nbsp;</span>;
    }
  };

  // const getlastrunStatus = (status) => {
  //   switch (status) {
  //     case "Failed":
  //       return <span className="rounded-md bg-red-500 p-1 text-white-500">{status}</span>
  //       break;
  //     case "Success":
  //       return <span className="rounded-md bg-green-500 p-1 text-white-500">{status}</span>
  //       break;
  //     case "Running":
  //       return <span className="rounded-md bg-blue-500 p-1 text-white-500">{status}</span>
  //       break;
  //     default:
  //       return <span className="rounded-md bg-gray-500 p-1 text-white-500">{status}</span>
  //       break;
  //   }
  // }

  const showItemDetails = (itemId) => {
    navigate(`/integrations/${itemId}/details`); // Navigate to the next page
  };

  const showInvocations = (itemId) => {
    navigate(`/integrations/${itemId}/invocations`); // Navigate to the next page
  };

  const SkeletonRow = () => {
    return (
      <>
        {[...Array(pageSize)].map((_, index) => (
          <tr key={index}>
            <td className="whitespace-nowrap px-4 py-2 text-sm font-medium">
              <div className="my-1 animate-pulse">
                <div className="h-6 w-52 bg-indigo-200 dark:bg-indigo-700"></div>
              </div>
            </td>
            <td className="whitespace-nowrap px-4 py-2 text-sm font-medium">
              <div className="my-1 animate-pulse">
                <div className="h-6 w-28 bg-indigo-200 dark:bg-indigo-700"></div>
              </div>
            </td>
            <td className="whitespace-nowrap px-4 py-2 text-sm font-medium">
              <div className="my-1 animate-pulse">
                <div className="h-6 w-28 bg-indigo-200 dark:bg-indigo-700"></div>
              </div>
            </td>
            <td className="whitespace-nowrap px-4 py-2 text-sm font-medium">
              <div className="my-1 animate-pulse">
                <div className="h-6 w-40 bg-indigo-200 dark:bg-indigo-700"></div>
              </div>
            </td>
            <td className="whitespace-nowrap px-4 py-2 text-sm font-medium">
              <div className="my-1 animate-pulse">
                <div className="h-6 w-60 bg-indigo-200 dark:bg-indigo-700"></div>
              </div>
            </td>
            <td className="whitespace-nowrap px-4 py-2 text-sm font-medium">
              <div className="my-1 animate-pulse">
                <div className="h-6 w-20 bg-indigo-200 dark:bg-indigo-700"></div>
              </div>
            </td>
          </tr>
        ))}
      </>
    );
  };

  if (error) {
    return <div className="mt-24">Error: {error.message}</div>;
  }

  return (
    <>
      <div
        className="mt-8 p-12 h-screen bg-gradient-to-br from-theme-primary to-theme-secondary"
        id="listing"
      >
        <section className="">
          <div className="sm:flex sm:items-center sm:justify-between">
            <div>
              <div className="flex items-center gap-x-3">
                <h2 className="text-2xl font-bold bg-gradient-to-r from-blue-400 via-purple-500 to-indigo-500 bg-clip-text text-transparent uppercase tracking-wide">
                  Integrations{" "}
                  <span className="bg-indigo-900 text-indigo-400 rounded-full px-2 text-sm">
                    {status === "loading" ? (
                      <span className="animate-pulse bg-indigo-900 text-indigo-400 rounded-full px-2 text-sm">
                        <span className="h-6 w-10 rounded-full bg-blue-100 dark:bg-gray-700"></span>
                      </span>
                    ) : (
                      <span className="bg-indigo-900 text-indigo-400 rounded-full px-2 text-sm">
                        {integrationsCount}
                      </span>
                    )}
                  </span>
                </h2>
              </div>
            </div>
            <div>
              <button
                onClick={gotoAddItem}
                className="flex w-1/2 items-center justify-center gap-x-2 rounded-lg bg-orange-500 px-2 py-2 text-sm text-white transition-colors duration-200 hover:bg-orange-600 focus:outline-none focus:ring sm:w-auto dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 dark:hover:bg-gray-800"
              >
                Launch Builder
              </button>
            </div>
          </div>

          <div className="mt-2 md:flex md:items-center md:justify-between">
            <div className="flex">
              <div className="bg-white inline-flex divide-x overflow-hidden rounded-lg border border-gray-500 rtl:flex-row-reverse dark:divide-gray-700 dark:border-gray-700 dark:bg-gray-900">
                <button
                  onClick={() => setListFilterStatus("All")}
                  className={`px-5 py-2 text-xs font-medium text-white transition-colors duration-200 sm:text-sm dark:text-gray-300 
                    ${listFilterStatus === "All"
                      ? "bg-theme-primary dark:bg-gray-700"
                      : "bg-theme-tertiary dark:bg-gray-800 hover:bg-theme-primary dark:hover:bg-gray-700"
                    }`}
                >
                  View all
                </button>

                <button
                  onClick={() => setListFilterStatus("Draft")}
                  className={`px-5 py-2 text-xs font-medium text-white transition-colors duration-200 sm:text-sm dark:text-gray-300 
                    ${listFilterStatus === "Draft"
                      ? "bg-theme-primary dark:bg-gray-700"
                      : "bg-theme-tertiary dark:bg-gray-800 hover:bg-theme-primary dark:hover:bg-gray-700"
                    }`}
                >
                  Draft
                </button>

                <button
                  onClick={() => setListFilterStatus("Running")}
                  className={`px-5 py-2 text-xs font-medium text-white transition-colors duration-200 sm:text-sm dark:text-gray-300 
                    ${listFilterStatus === "Running"
                      ? "bg-theme-primary dark:bg-gray-700"
                      : "bg-theme-tertiary dark:bg-gray-800 hover:bg-theme-primary dark:hover:bg-gray-700"
                    }`}
                >
                  Running
                </button>

                <button
                  onClick={() => setListFilterStatus("Stopped")}
                  className={`px-5 py-2 text-xs font-medium text-white transition-colors duration-200 sm:text-sm dark:text-gray-300 
                  ${listFilterStatus === "Stopped"
                      ? "bg-theme-primary dark:bg-gray-700"
                      : "bg-theme-tertiary dark:bg-gray-800 hover:bg-theme-primary dark:hover:bg-gray-700"
                    }`}
                >
                  Stopped
                </button>
              </div>

              <div className="ml-4">
                <button
                  onClick={handleRefresh}
                  className="rounded-md bg-theme-tertiary p-2 hover:bg-theme-primary text-white border"
                >
                  Refresh
                </button>
              </div>
            </div>

            <div className="relative mt-4 flex items-center md:mt-0">
              <span className="absolute">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="mx-3 h-5 w-5 text-gray-400 dark:text-gray-600"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
                  />
                </svg>
              </span>

              <input
                type="text"
                placeholder="Search"
                className="bg-white block w-full rounded-lg border border-gray-500 py-1.5 pl-11 pr-5 text-gray-700 placeholder-gray-400/70 focus:border-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-40 md:w-80 rtl:pl-5 rtl:pr-11 dark:border-gray-600 dark:bg-gray-900 dark:text-gray-300 dark:focus:border-blue-300"
              />
            </div>
          </div>

          <div className="mt-2 flex flex-col">
            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                <div className="overflow-hidden border border-gray-500 bg-white-500 md:rounded-lg dark:border-gray-700">
                  <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                    <thead className="bg-theme-primary dark:bg-gray-800">
                      <tr>
                        <th
                          scope="col"
                          className="border-b border-gray-500 px-4 py-3.5 text-left text-sm font-normal text-white rtl:text-right dark:text-gray-400"
                        >
                          <button className="flex items-center gap-x-3 focus:outline-none">
                            <span>Name</span>
                            <svg
                              className="h-3"
                              viewBox="0 0 10 11"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M2.13347 0.0999756H2.98516L5.01902 4.79058H3.86226L3.45549 3.79907H1.63772L1.24366 4.79058H0.0996094L2.13347 0.0999756ZM2.54025 1.46012L1.96822 2.92196H3.11227L2.54025 1.46012Z"
                                fill="currentColor"
                                stroke="currentColor"
                                strokeWidth="0.1"
                              />
                              <path
                                d="M0.722656 9.60832L3.09974 6.78633H0.811638V5.87109H4.35819V6.78633L2.01925 9.60832H4.43446V10.5617H0.722656V9.60832Z"
                                fill="currentColor"
                                stroke="currentColor"
                                strokeWidth="0.1"
                              />
                              <path
                                d="M8.45558 7.25664V7.40664H8.60558H9.66065C9.72481 7.40664 9.74667 7.42274 9.75141 7.42691C9.75148 7.42808 9.75146 7.42993 9.75116 7.43262C9.75001 7.44265 9.74458 7.46304 9.72525 7.49314C9.72522 7.4932 9.72518 7.49326 9.72514 7.49332L7.86959 10.3529L7.86924 10.3534C7.83227 10.4109 7.79863 10.418 7.78568 10.418C7.77272 10.418 7.73908 10.4109 7.70211 10.3534L7.70177 10.3529L5.84621 7.49332C5.84617 7.49325 5.84612 7.49318 5.84608 7.49311C5.82677 7.46302 5.82135 7.44264 5.8202 7.43262C5.81989 7.42993 5.81987 7.42808 5.81994 7.42691C5.82469 7.42274 5.84655 7.40664 5.91071 7.40664H6.96578H7.11578V7.25664V0.633865C7.11578 0.42434 7.29014 0.249976 7.49967 0.249976H8.07169C8.28121 0.249976 8.45558 0.42434 8.45558 0.633865V7.25664Z"
                                fill="currentColor"
                                stroke="currentColor"
                                strokeWidth="0.3"
                              />
                            </svg>
                          </button>
                        </th>

                        {/* <th
                            scope="col"
                            className="px-12 py-3.5 text-left text-sm font-normal text-gray-600 rtl:text-right dark:text-gray-400"
                          >
                            Status
                          </th> */}

                        <th
                          scope="col"
                          className="border-b border-gray-500 px-4 py-3.5 text-left text-sm font-normal text-white rtl:text-right dark:text-gray-400"
                        >
                          Status
                        </th>

                        <th
                          scope="col"
                          className="border-b border-gray-500 px-4 py-3.5 text-left text-sm font-normal text-white rtl:text-right dark:text-gray-400"
                        >
                          Created at
                        </th>

                        <th
                          scope="col"
                          className="border-b border-gray-500 px-4 py-3.5 text-left text-sm font-normal text-white rtl:text-right dark:text-gray-400"
                        >
                          Last Executed at
                        </th>

                        <th
                          scope="col"
                          className="border-b border-gray-500 px-4 py-3.5 text-left text-sm font-normal text-white rtl:text-right dark:text-gray-400"
                        >
                          Description
                        </th>

                        <th
                          scope="col"
                          className="relative border-b border-gray-500 px-4 py-3.5"
                        >
                          <span className="sr-only">Edit</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-theme-tertiary divide-y divide-gray-200 border-t border-gray-500 dark:divide-gray-700 dark:bg-gray-900">
                      {status === "loading" && <SkeletonRow />}
                      {status === "succeeded" &&
                        integrations.map((itemData, index) => (
                          <tr key={index} className="">
                            <td className="whitespace-nowrap px-4 py-2 text-sm font-medium">
                              <div>
                                <button
                                  onClick={() =>
                                    showItemDetails(itemData.integration_id)
                                  }
                                  className="rounded-lg px-1 py-1 text-white transition-colors duration-200 hover:bg-gray-300 hover:text-gray-900 dark:text-gray-300"
                                >
                                  <h2 className="dark:text-white font-medium">
                                    {itemData.name}
                                  </h2>
                                </button>
                                {/* <p className="text-sm font-normal text-gray-600 dark:text-gray-400">catalogapp.io</p> */}
                              </div>
                            </td>
                            {/* <td className="whitespace-nowrap px-12 py-4 text-sm font-medium">
                                    <div className="text-emerald-500 bg-emerald-100/60 inline gap-x-2 rounded-full px-3 py-1 text-sm font-normal dark:bg-gray-800">
                                        Running
                                    </div>
                                </td> */}

                            <td className="whitespace-nowrap px-4 py-2 text-sm">
                              <div>
                                <h4 className="text-gray-700 dark:text-gray-200">
                                  {getStatus(itemData.status)}
                                </h4>
                                {/* <p className="text-gray-600 dark:text-gray-400">Brings all your news into one place</p> */}
                              </div>
                            </td>

                            <td className="whitespace-nowrap px-4 py-2 text-sm text-white">
                              <div className="flex items-center">
                                {formatDate(itemData.createdAt)} (
                                <ReactTimeAgo
                                  date={itemData.createdAt}
                                  locale="en-US"
                                />
                                )
                              </div>
                            </td>

                            <td className="whitespace-nowrap px-4 py-2 text-sm">
                              <div className="flex items-center">
                                {itemData.lastExecutedAt === null ? (
                                  <span className="me-2 rounded-md bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-900 dark:bg-gray-900 dark:text-gray-300">
                                    Never
                                  </span>
                                ) : (
                                  <div className="flex items-center space-x-2">

                                    <span className="text-white">
                                      {formatDate(itemData.lastExecutedAt)}
                                    </span>
                                    {/* <span className="ml-1">
                                      <StatusIcon
                                        status={itemData.lastRunStatus}
                                      />
                                    </span> */}
                                    <button title="Flow Insights"
                                      onClick={() =>
                                        showInvocations(itemData.integration_id)
                                      }
                                      className="flex items-center whitespace-nowrap bg-green-300 text-white rounded-lg p-1 hover:bg-gray-300 hover:bg-opacity-50 dark:hover:bg-gray-700 transition-colors duration-200"
                                    >
                                      <svg className="h-6 w-6" viewBox="0 0 16 16" fill="none"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                      <g id="SVGRepo_iconCarrier"> <g fill="#000000"> <path d="M5.314 1.256a.75.75 0 01-.07 1.058L3.889 3.5l1.355 1.186a.75.75 0 11-.988 1.128l-2-1.75a.75.75 0 010-1.128l2-1.75a.75.75 0 011.058.07zM7.186 1.256a.75.75 0 00.07 1.058L8.611 3.5 7.256 4.686a.75.75 0 10.988 1.128l2-1.75a.75.75 0 000-1.128l-2-1.75a.75.75 0 00-1.058.07zM2.75 7.5a.75.75 0 000 1.5h10.5a.75.75 0 000-1.5H2.75zM2 11.25a.75.75 0 01.75-.75h10.5a.75.75 0 010 1.5H2.75a.75.75 0 01-.75-.75zM2.75 13.5a.75.75 0 000 1.5h6.5a.75.75 0 000-1.5h-6.5z"></path> </g> </g></svg>
                                    </button>
                                  </div>
                                )}
                              </div>
                            </td>

                            <td className="whitespace-nowrap px-4 py-2 text-sm text-white">
                              <div className="flex items-center">
                                {itemData.description}
                              </div>
                            </td>

                            <td className="whitespace-nowrap px-4 py-2 text-sm">
                              <button
                                onClick={() =>
                                  editItem(itemData.integration_id)
                                }
                                className="rounded-lg px-1 py-1 text-white transition-colors duration-200 hover:bg-gray-300 dark:text-gray-300"
                              >
                                <svg
                                  className="h-6 w-6"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                  <g
                                    id="SVGRepo_tracerCarrier"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  ></g>
                                  <g id="SVGRepo_iconCarrier">
                                    {" "}
                                    <path
                                      d="M21.2799 6.40005L11.7399 15.94C10.7899 16.89 7.96987 17.33 7.33987 16.7C6.70987 16.07 7.13987 13.25 8.08987 12.3L17.6399 2.75002C17.8754 2.49308 18.1605 2.28654 18.4781 2.14284C18.7956 1.99914 19.139 1.92124 19.4875 1.9139C19.8359 1.90657 20.1823 1.96991 20.5056 2.10012C20.8289 2.23033 21.1225 2.42473 21.3686 2.67153C21.6147 2.91833 21.8083 3.21243 21.9376 3.53609C22.0669 3.85976 22.1294 4.20626 22.1211 4.55471C22.1128 4.90316 22.0339 5.24635 21.8894 5.5635C21.7448 5.88065 21.5375 6.16524 21.2799 6.40005V6.40005Z"
                                      stroke="#FFFFFF"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    ></path>{" "}
                                    <path
                                      d="M11 4H6C4.93913 4 3.92178 4.42142 3.17163 5.17157C2.42149 5.92172 2 6.93913 2 8V18C2 19.0609 2.42149 20.0783 3.17163 20.8284C3.92178 21.5786 4.93913 22 6 22H17C19.21 22 20 20.2 20 18V13"
                                      stroke="#FFFFFF"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    ></path>{" "}
                                  </g>
                                </svg>
                                {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-6 w-6">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                                        </svg> */}
                              </button>
                              <button
                                onClick={() =>
                                  deleteItem(itemData.integration_id)
                                }
                                className="rounded-lg px-1 py-1 text-gray-600 transition-colors duration-200 hover:bg-gray-300 dark:text-gray-300"
                              >
                                <svg
                                  className="h-6 w-6"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                  <g
                                    id="SVGRepo_tracerCarrier"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  ></g>
                                  <g id="SVGRepo_iconCarrier">
                                    {" "}
                                    <path
                                      d="M10 11V17"
                                      stroke="#FF0000"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    ></path>{" "}
                                    <path
                                      d="M14 11V17"
                                      stroke="#FF0000"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    ></path>{" "}
                                    <path
                                      d="M4 7H20"
                                      stroke="#FF0000"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    ></path>{" "}
                                    <path
                                      d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z"
                                      stroke="#FF0000"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    ></path>{" "}
                                    <path
                                      d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z"
                                      stroke="#FF0000"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    ></path>{" "}
                                  </g>
                                </svg>
                              </button>
                            </td>
                          </tr>
                        ))}
                      {integrations.length === 0 && status === "succeeded" && (
                        <tr>
                          <td
                            colSpan="6"
                            className="whitespace-nowrap px-4 py-2 text-center text-sm font-medium"
                            style={{ color: "red" }}
                          >
                            No Integrations available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                {integrations.length > 0 && (
                  <div className=" mt-2 flex items-center justify-center">
                    {status === "loading" ? (
                      <div className="my-1 animate-pulse">
                        <div className="h-10 w-96 bg-gray-200 dark:bg-gray-700"></div>
                      </div>
                    ) : (
                      <div className="flex select-none space-x-1 text-gray-700">
                        <button
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1}
                          className={`px-4 py-2 transition duration-300 border text-white rounded-md ${currentPage === 1
                            ? "bg-theme-primary cursor-not-allowed"
                            : "bg-theme-tertiary hover:bg-theme-primary hover:text-white"
                            }`}
                        >
                          Previous
                        </button>

                        {Array.from(
                          { length: totalPages() },
                          (_, index) => index + 1
                        ).map((page) => (
                          <button
                            key={page}
                            onClick={() =>
                              currentPage != page
                                ? handlePageChange(page)
                                : undefined
                            }
                            className={`px-4 py-2 transition duration-300 border text-white rounded-md ${currentPage === page
                              ? "bg-theme-primary text-white"
                              : "bg-theme-tertiary hover:bg-theme-primary hover:text-white"
                              }`}
                          >
                            {page}
                          </button>
                        ))}

                        <button
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={currentPage === totalPages()}
                          className={`px-4 py-2 transition duration-300 border text-white rounded-md ${currentPage === totalPages()
                            ? "bg-theme-primary cursor-not-allowed"
                            : "bg-theme-tertiary hover:bg-theme-primary hover:text-white"
                            }`}
                        >
                          Next
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
      <ModalConfirm
        isOpen={selectedItemToDelete !== null}
        onCancel={onConfirmCancel}
        onConfirm={onConfirm}
        title={"Delete Integration"}
      >
        <div>Are you sure you want to delete this integration?</div>
      </ModalConfirm>
    </>
  );
};

export default Listing;
